import { inject, injectable } from "inversify";
import {
  CPLServiceChargeInvoicingSummariesClient,
  ReportURLResponseModel,
  ServiceChargeInvoiceDetailsModel,
  ServiceChargeInvoiceSummaryModel,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IServiceChargeInvoicingSummariesService {
  getServiceChargeInvoiceSummaries(): Promise<ServiceChargeInvoiceSummaryModel[]>;
  getServiceChargeInvoiceDetails(logID: number): Promise<ServiceChargeInvoiceDetailsModel>;
  downloadServiceChargeInvoice(breakdownID: number): Promise<File>;
  resendServiceChargeInvoiceEmails(breakdownIDs: number[]): Promise<void>;
  resendServiceChargeInvoicePrints(breakdownIDs: number[]): Promise<ReportURLResponseModel>;
}

@injectable()
export class ServiceChargeInvoicingSummariesService implements IServiceChargeInvoicingSummariesService {
  @inject(SERVICE_TYPES.CPLServiceChargeInvoicingSummariesClient)
  serviceChargeInvoicingSummariesClient!: CPLServiceChargeInvoicingSummariesClient;

  async getServiceChargeInvoiceSummaries(): Promise<ServiceChargeInvoiceSummaryModel[]> {
    return this.serviceChargeInvoicingSummariesClient.getServiceChargeInvoiceSummaries();
  }

  async getServiceChargeInvoiceDetails(logID: number): Promise<ServiceChargeInvoiceDetailsModel> {
    return this.serviceChargeInvoicingSummariesClient.getServiceChargeInvoiceDetails(logID);
  }

  async downloadServiceChargeInvoice(breakdownID: number): Promise<File> {
    const fileResponse = await this.serviceChargeInvoicingSummariesClient.downloadServiceChargeInvoice(breakdownID);
    return new File([fileResponse.data], fileResponse.fileName!);
  }

  async resendServiceChargeInvoiceEmails(breakdownIDs: number[]): Promise<void> {
    return this.serviceChargeInvoicingSummariesClient.resendServiceChargeInvoiceEmails(breakdownIDs);
  }

  async resendServiceChargeInvoicePrints(breakdownIDs: number[]): Promise<ReportURLResponseModel> {
    return this.serviceChargeInvoicingSummariesClient.resendServiceChargeInvoicePrints(breakdownIDs);
  }
}
